import React from "react";

const HeaderComponent = ({title,lineClass,titleClass}) => {
    return (
        <div className="fifth-des-header-component">
            <div className={lineClass}></div>
            <h1 className={titleClass}>
                {title}
            </h1>
            <div className={lineClass}></div>
        </div>
    )
}
export default HeaderComponent